<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="4172.000000pt"
    height="50.000000pt"
    viewBox="0 0 4172.000000 550.000000"
    preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,550.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
      <path
        d="M245 5308 c-3 -7 -4 -1149 -3 -2538 l3 -2525 395 0 395 0 0 2535 0
2535 -393 3 c-309 2 -394 0 -397 -10z" />
      <path
        d="M2530 2780 l0 -2540 393 2 392 3 0 2535 0 2535 -392 3 -393 2 0
-2540z" />
      <path
        d="M6411 5306 c-6 -7 -20 -40 -30 -72 -30 -93 -99 -310 -131 -409 -15
-49 -47 -151 -70 -225 -23 -74 -52 -166 -65 -205 -13 -38 -44 -137 -70 -220
-76 -244 -96 -306 -120 -380 -13 -38 -34 -106 -48 -150 -80 -255 -122 -388
-142 -450 -13 -38 -44 -137 -70 -220 -77 -246 -96 -307 -120 -380 -13 -38 -44
-137 -70 -220 -26 -82 -58 -186 -72 -230 -14 -44 -35 -111 -48 -150 -24 -74
-44 -136 -120 -380 -26 -82 -57 -181 -70 -220 -20 -62 -62 -195 -142 -450 -14
-44 -35 -111 -48 -150 -13 -38 -42 -131 -65 -205 -23 -74 -55 -175 -71 -224
-16 -49 -29 -95 -29 -103 0 -11 72 -13 402 -11 l402 3 32 100 c17 55 57 181
89 280 31 99 60 191 65 205 5 14 30 93 55 175 26 83 57 182 70 220 20 62 62
195 142 450 14 44 35 112 48 150 21 65 49 151 191 605 31 96 59 186 64 200 5
14 30 93 55 175 26 83 57 182 70 220 13 39 42 131 65 205 23 74 48 153 55 175
8 22 26 78 40 125 14 47 43 139 65 205 21 66 51 161 67 210 l28 90 5 -1895 5
-1895 390 0 390 0 3 2524 c2 2013 0 2526 -10 2533 -7 4 -275 8 -594 8 -479 0
-584 -2 -593 -14z" />
      <path
        d="M10832 5312 c-10 -7 -12 -520 -10 -2533 l3 -2524 1245 0 c1176 0
1250 1 1340 19 219 43 404 120 585 245 94 64 282 249 347 341 280 395 351 879
195 1335 -85 249 -252 488 -467 667 l-54 45 30 39 c136 174 238 392 286 614
29 131 31 445 4 565 -72 321 -189 540 -405 756 -133 132 -240 209 -396 284
-179 87 -294 119 -505 141 -106 11 -352 14 -1160 14 -564 0 -1031 -4 -1038 -8z
m2271 -819 c115 -44 181 -86 268 -173 71 -71 93 -101 126 -170 58 -124 68
-168 67 -305 0 -103 -4 -131 -26 -196 -38 -107 -91 -192 -168 -269 -75 -76
-158 -126 -275 -167 l-80 -27 -702 -4 -703 -3 0 671 0 671 718 -3 c710 -3 718
-3 775 -25z m157 -2113 c355 -57 611 -399 560 -748 -38 -262 -211 -470 -465
-559 l-80 -28 -832 -3 -833 -3 0 676 0 675 793 0 c494 0 816 -4 857 -10z" />
      <path
        d="M15492 5312 c-10 -7 -12 -520 -10 -2533 l3 -2524 1603 -3 1602 -2 0
395 0 395 -1210 0 -1210 0 0 673 0 674 758 6 c416 4 907 7 1090 7 l332 0 -2
387 -3 388 -1087 3 -1088 2 0 675 0 675 1210 0 1210 0 0 395 0 395 -1592 0
c-876 0 -1599 -4 -1606 -8z" />
      <path
        d="M19782 5312 c-10 -7 -12 -520 -10 -2533 l3 -2524 390 0 390 0 5 1890
c4 1408 8 1884 16 1865 6 -14 24 -65 39 -115 15 -49 37 -121 50 -160 27 -83
130 -408 152 -480 8 -27 25 -81 38 -120 29 -89 132 -414 152 -480 8 -27 26
-81 38 -120 13 -38 34 -106 48 -150 56 -180 121 -384 142 -450 13 -38 42 -131
65 -205 23 -74 52 -166 65 -205 12 -38 44 -137 70 -220 25 -82 50 -161 55
-175 5 -14 34 -106 65 -205 31 -99 75 -236 96 -305 22 -69 54 -168 70 -220 17
-52 35 -107 41 -123 l10 -27 603 0 603 0 36 118 c21 64 41 128 46 142 5 14 30
93 55 175 26 83 57 182 70 220 13 39 42 131 65 205 23 74 48 153 55 175 8 22
26 78 40 125 14 47 43 139 65 205 21 66 59 188 85 270 66 210 125 396 135 425
5 14 30 93 55 175 26 83 50 161 55 175 11 32 75 232 135 425 26 83 64 204 85
270 22 66 51 158 65 205 15 47 33 103 40 125 8 22 38 114 67 205 l53 165 5
-1900 5 -1900 388 -3 387 -2 -2 2532 -3 2533 -583 3 c-345 1 -590 -2 -600 -7
-10 -5 -26 -38 -37 -73 -10 -35 -31 -101 -45 -148 -15 -47 -40 -123 -54 -170
-15 -47 -44 -139 -66 -205 -21 -66 -59 -187 -85 -270 -25 -82 -50 -161 -55
-175 -10 -29 -69 -215 -135 -425 -26 -82 -64 -204 -85 -270 -22 -66 -51 -158
-65 -205 -15 -47 -33 -103 -40 -125 -8 -22 -33 -101 -55 -175 -23 -74 -52
-166 -65 -205 -30 -93 -74 -230 -125 -395 -23 -74 -52 -166 -65 -205 -13 -38
-44 -137 -70 -220 -77 -246 -96 -307 -120 -380 -13 -38 -44 -137 -70 -220 -25
-82 -50 -161 -55 -175 -5 -14 -32 -98 -61 -188 -28 -90 -55 -160 -59 -155 -4
4 -31 82 -60 173 -28 91 -69 219 -90 285 -21 66 -64 201 -95 300 -31 99 -74
234 -95 300 -21 66 -64 201 -95 300 -31 99 -74 234 -95 300 -21 66 -64 201
-95 300 -31 99 -60 191 -65 205 -5 14 -30 93 -55 175 -26 83 -57 182 -70 220
-13 39 -42 131 -65 205 -23 74 -48 153 -55 175 -8 22 -26 78 -40 125 -14 47
-43 139 -65 205 -21 66 -59 188 -85 270 -25 83 -50 161 -55 175 -12 34 -78
242 -135 425 -26 83 -54 173 -64 200 l-17 50 -589 2 c-325 2 -596 -1 -603 -5z" />
      <path
        d="M32845 5232 c-103 -50 -142 -155 -96 -257 54 -120 215 -152 317 -63
49 43 64 78 64 145 0 73 -23 118 -79 157 -57 38 -147 46 -206 18z" />
      <path
        d="M39755 5232 c-191 -92 -127 -372 85 -372 71 0 154 49 186 111 20 40
18 137 -5 179 -44 84 -177 124 -266 82z" />
      <path
        d="M27367 5234 c-4 -4 -7 -461 -7 -1016 l0 -1008 185 0 185 0 -2 1013
-3 1012 -176 3 c-96 1 -178 -1 -182 -4z" />
      <path
        d="M32120 4225 l0 -1015 175 0 175 0 -2 1013 -3 1012 -172 3 -173 2 0
-1015z" />
      <path
        d="M35439 5163 c-35 -43 -80 -98 -100 -123 -21 -25 -63 -75 -93 -111
-30 -37 -52 -69 -49 -73 4 -3 66 -6 139 -6 l134 0 86 110 c48 61 91 110 95
110 5 0 48 -49 95 -110 l87 -110 139 0 c76 0 138 3 138 6 0 8 -55 77 -188 237
l-124 147 -148 0 -149 0 -62 -77z" />
      <path
        d="M29757 5033 c-4 -3 -7 -91 -7 -194 l0 -188 -122 -3 -123 -3 0 -135 0
-135 122 -3 122 -3 3 -442 c4 -497 5 -503 79 -589 74 -88 175 -117 402 -118
l157 0 0 135 0 135 -95 0 c-109 0 -166 17 -184 56 -8 17 -11 148 -11 424 l0
400 129 0 c71 0 136 3 145 6 14 5 16 27 16 140 l0 134 -145 0 -145 0 0 179 c0
99 -3 186 -6 195 -5 14 -30 16 -168 16 -90 0 -166 -3 -169 -7z" />
      <path
        d="M28723 4669 c-118 -20 -220 -80 -298 -176 l-45 -55 0 106 0 106 -167
-2 -168 -3 0 -710 0 -710 167 -3 166 -2 5 452 c5 510 6 520 78 602 23 25 64
57 97 73 49 23 69 27 142 27 102 0 161 -24 215 -86 68 -80 68 -81 73 -600 l4
-468 169 0 169 0 0 483 c0 540 -4 586 -65 713 -91 189 -311 292 -542 253z" />
      <path
        d="M31090 4674 c-264 -48 -445 -210 -537 -479 -25 -75 -27 -91 -27 -260
-1 -169 1 -185 26 -265 63 -199 176 -335 342 -415 105 -50 180 -65 316 -65
146 0 227 17 340 72 146 71 286 235 306 356 l7 42 -156 0 -155 0 -31 -54 c-56
-100 -149 -146 -297 -146 -152 0 -255 54 -317 167 -27 51 -57 150 -57 190 l0
23 515 0 515 0 0 114 c0 144 -20 236 -75 351 -87 180 -227 301 -407 351 -53
14 -261 27 -308 18z m273 -298 c98 -47 187 -174 187 -266 l0 -30 -351 0 c-329
0 -350 1 -345 18 3 9 8 31 12 47 28 122 127 225 248 256 62 16 188 3 249 -25z" />
      <path
        d="M33885 4674 c-57 -8 -150 -36 -197 -60 -74 -37 -162 -117 -211 -191
-99 -150 -131 -264 -131 -478 -1 -208 31 -334 120 -470 120 -185 299 -274 526
-262 160 8 238 44 338 155 l60 67 0 -135 c0 -81 -5 -156 -13 -188 -37 -139
-157 -217 -333 -215 -127 1 -236 57 -278 140 l-21 42 -162 1 -163 0 0 -25 c0
-67 63 -186 139 -262 121 -120 363 -181 610 -153 242 27 419 132 496 297 62
131 59 77 62 931 l4 782 -165 0 -165 0 -3 -102 -3 -103 -20 25 c-77 96 -160
154 -264 186 -48 14 -178 25 -226 18z m267 -294 c170 -50 273 -252 254 -494
-21 -253 -174 -408 -388 -394 -124 8 -226 78 -279 192 -41 87 -52 161 -46 301
7 157 32 228 110 312 45 49 79 70 147 89 49 15 143 12 202 -6z" />
      <path
        d="M35545 4674 c-11 -2 -40 -9 -65 -15 -173 -41 -339 -175 -424 -345
-114 -227 -114 -540 0 -767 39 -78 79 -131 150 -196 124 -113 259 -161 462
-161 92 0 141 5 200 21 213 56 375 198 437 382 9 26 13 52 10 57 -4 6 -69 10
-156 10 l-150 0 -17 -32 c-30 -59 -105 -124 -168 -148 -50 -18 -75 -21 -164
-18 -86 3 -114 8 -155 28 -99 48 -162 139 -190 271 -8 38 -15 72 -15 75 0 2
233 5 518 6 l517 3 3 60 c5 89 -14 231 -43 314 -38 113 -91 199 -169 276 -124
122 -252 174 -441 180 -66 2 -129 2 -140 -1z m257 -293 c97 -41 152 -103 187
-209 34 -101 68 -92 -330 -92 l-351 0 7 43 c20 133 127 250 255 278 59 13 181
3 232 -20z" />
      <path
        d="M37255 4671 c-115 -19 -213 -75 -292 -167 l-48 -56 -5 99 -5 98 -167
3 -168 2 0 -715 0 -715 170 0 170 0 0 413 c0 226 5 441 10 476 19 134 95 224
216 256 73 19 105 19 178 0 87 -23 152 -82 181 -165 5 -14 12 -239 15 -500 l5
-475 170 0 170 0 3 455 c3 475 -2 571 -39 679 -51 147 -159 248 -319 297 -58
18 -181 25 -245 15z" />
      <path
        d="M38685 4674 c-11 -2 -45 -9 -75 -16 -137 -28 -299 -138 -379 -257
-106 -158 -156 -373 -131 -568 42 -330 224 -554 508 -627 103 -26 289 -22 395
9 212 61 371 217 421 412 29 111 41 103 -149 103 l-165 0 -11 -27 c-47 -120
-82 -166 -156 -203 -67 -34 -214 -35 -285 -3 -61 28 -131 98 -163 164 -96 199
-61 512 72 643 140 138 382 120 488 -36 19 -29 35 -58 35 -65 0 -7 5 -24 12
-38 l11 -25 165 0 165 0 -7 45 c-8 60 -51 169 -90 225 -74 108 -179 187 -313
232 -74 25 -107 30 -208 33 -66 2 -129 2 -140 -1z" />
      <path
        d="M40800 4671 c-255 -37 -423 -165 -484 -370 -29 -97 -39 -91 148 -91
l164 0 7 29 c20 93 124 161 256 169 123 7 215 -31 261 -108 28 -47 31 -139 5
-168 -19 -21 -107 -44 -217 -57 -257 -31 -378 -57 -470 -102 -62 -30 -144
-103 -167 -148 -57 -109 -57 -278 1 -405 68 -152 308 -252 532 -221 125 17
195 53 278 143 l66 70 0 -96 0 -96 168 2 167 3 3 490 c2 356 0 509 -9 560 -34
192 -163 323 -368 376 -85 22 -257 32 -341 20z m378 -893 c-4 -90 -9 -121 -26
-155 -34 -66 -78 -110 -140 -140 -52 -25 -67 -28 -167 -28 -85 0 -118 4 -145
17 -78 39 -103 78 -103 157 0 66 22 106 76 139 40 25 146 58 212 67 68 9 247
44 253 50 3 3 14 5 25 5 18 0 19 -6 15 -112z" />
      <path d="M32750 3930 l0 -720 175 0 175 0 0 720 0 720 -175 0 -175 0 0 -720z" />
      <path d="M39660 3930 l0 -720 175 0 175 0 0 720 0 720 -175 0 -175 0 0 -720z" />
      <path
        d="M28337 2334 c-4 -4 -7 -181 -7 -393 l-1 -386 -21 29 c-60 81 -120
126 -214 163 -61 24 -83 27 -189 27 -176 1 -289 -41 -400 -149 -127 -123 -189
-260 -216 -478 -21 -176 10 -379 81 -519 89 -177 226 -285 407 -322 196 -41
358 6 490 141 l72 73 3 -97 3 -98 165 0 165 0 0 1005 0 1005 -166 3 c-91 1
-168 -1 -172 -4z m-269 -848 c179 -48 281 -209 282 -442 0 -208 -74 -359 -215
-432 -44 -24 -61 -27 -150 -27 -89 0 -106 3 -150 27 -137 72 -205 214 -205
428 0 242 94 397 268 445 63 18 106 18 170 1z" />
      <path
        d="M31160 1330 l0 -1010 385 0 c422 0 517 8 660 56 117 39 176 69 264
134 236 175 357 457 355 830 -2 461 -203 791 -565 930 -158 60 -260 70 -708
70 l-391 0 0 -1010z m906 673 c92 -30 156 -69 219 -131 138 -139 205 -397 172
-667 -37 -299 -153 -462 -382 -541 -77 -27 -90 -28 -317 -32 l-238 -4 0 702 0
702 243 -5 c208 -3 251 -7 303 -24z" />
      <path
        d="M35567 2333 c-4 -3 -7 -177 -7 -385 0 -208 -2 -378 -4 -378 -2 0 -32
29 -66 64 -102 106 -231 153 -395 142 -262 -16 -447 -167 -540 -441 -23 -65
-45 -212 -45 -294 0 -236 74 -445 205 -577 142 -142 345 -203 533 -159 125 30
207 84 295 194 l27 35 0 -107 0 -107 165 0 165 0 0 1010 0 1010 -163 0 c-90 0
-167 -3 -170 -7z m-269 -847 c192 -51 298 -241 278 -501 -13 -181 -80 -300
-208 -371 -49 -27 -61 -29 -153 -29 -84 1 -108 4 -147 24 -137 67 -208 214
-208 430 0 203 59 338 179 409 82 49 169 62 259 38z" />
      <path
        d="M29417 1761 c-342 -95 -544 -432 -498 -830 47 -401 307 -641 696
-641 281 0 519 142 615 367 47 109 54 103 -124 103 l-155 0 -38 -57 c-64 -97
-159 -143 -293 -143 -140 0 -244 54 -307 158 -37 61 -57 122 -57 181 l-1 46
513 3 512 2 0 99 c0 338 -169 599 -452 698 -101 36 -308 43 -411 14z m317
-271 c29 -12 74 -39 100 -61 51 -45 104 -143 113 -208 l6 -41 -352 0 c-294 0
-351 2 -351 14 0 36 44 146 75 188 63 85 153 127 277 128 54 0 94 -6 132 -20z" />
      <path
        d="M33530 1769 c-126 -18 -239 -70 -322 -148 -72 -67 -110 -129 -133
-216 -26 -103 -38 -95 150 -95 l164 0 7 37 c9 50 83 122 149 146 77 26 206 23
270 -7 61 -29 90 -58 110 -115 22 -64 19 -96 -12 -131 -31 -34 -90 -48 -283
-70 -446 -51 -610 -169 -610 -439 1 -259 159 -411 445 -428 115 -7 214 7 282
39 51 24 142 103 162 142 8 14 18 26 23 26 4 0 8 -43 8 -95 l0 -95 165 0 166
0 -3 558 -3 557 -23 50 c-71 153 -215 252 -413 285 -73 11 -218 11 -299 -1z
m408 -881 c-3 -99 -7 -120 -32 -168 -38 -76 -61 -98 -136 -133 -58 -27 -75
-30 -165 -31 -74 0 -111 5 -140 18 -154 67 -153 247 2 316 48 21 133 41 278
65 55 10 118 23 140 31 22 7 44 13 49 14 4 0 6 -51 4 -112z" />
      <path
        d="M36655 1761 c-239 -59 -417 -241 -487 -499 -17 -62 -21 -105 -21
-227 0 -122 4 -165 21 -227 26 -95 64 -177 112 -243 131 -178 330 -275 565
-275 339 0 590 192 681 520 26 92 26 357 0 450 -72 261 -243 436 -491 501 -93
25 -281 25 -380 0z m273 -272 c107 -25 209 -127 245 -243 75 -243 15 -512
-136 -613 -66 -44 -116 -56 -217 -51 -98 5 -148 26 -210 88 -81 81 -120 199
-120 365 0 244 88 396 263 450 53 17 112 18 175 4z" />
      <path
        d="M38190 1774 c-190 -34 -338 -130 -398 -257 -71 -152 -38 -346 78
-450 91 -82 177 -115 440 -167 150 -29 207 -50 254 -91 38 -34 40 -39 40 -90
0 -92 -62 -148 -186 -169 -171 -29 -317 40 -350 166 l-12 44 -166 -2 -165 -3
3 -35 c8 -97 67 -207 148 -279 63 -56 187 -115 286 -135 101 -21 284 -21 379
0 281 61 442 257 409 494 -21 148 -112 243 -295 305 -48 17 -95 28 -278 65
-184 38 -254 75 -277 146 -16 48 4 107 51 149 120 108 355 70 423 -68 15 -28
26 -59 26 -69 0 -17 12 -18 160 -18 l160 0 0 25 c0 29 -23 118 -41 160 -45
105 -165 204 -305 251 -68 23 -99 27 -219 29 -77 2 -151 1 -165 -1z" />
    </g>
  </svg>
</template>
